import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from 'src/app/core/translate';
import { IDIALOG_DATA } from 'src/app/shared/models/dialog-data.model';

@Component({
    selector: 'app-history-service',
    templateUrl: './history-service.component.html',
    styleUrls: ['./history-service.component.scss']
})
export class HistoryServiceComponent implements OnInit {
    isLoading!: boolean;
    isShowReason!: boolean;
    prefixTicketCode!: string;
    globalSlaCount!: number;
    historyData: any;
    lang!: string;
    constructor(
        public dialogRef: MatDialogRef<HistoryServiceComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: IDIALOG_DATA,
        private _translateService: TranslateService
    ) {}

    ngOnInit(): void {
        this.lang = this._translateService.currentLang === LANGUAGES.EN ? 'en' : 'ar';

        this.getHistoryData();
    }
    calculateDayDifferences(): void {
        const getDateDifference =(curr, prev) => {
            return Math.abs(curr-prev)
        }
        this.historyData = this.historyData.slice().reverse(); // change the order coming from the backend
        // setting difference for the first item
        this.historyData[0].dayDifference = 0;
        this.historyData[0].differenceFromStart = 0;
        const firstActionDate = new Date(this.historyData[0].statusChangedAt);
        this.historyData.reduce((prev, curr, index) => {
            if (index > 0) {
                const prevDate = new Date(prev.statusChangedAt);
                const currDate = new Date(curr.statusChangedAt);
                const dayDifference = Math.floor(getDateDifference(currDate, prevDate) / (1000 * 60 * 60 * 24));
                const dayDifferenceFromStart = Math.floor(getDateDifference(currDate, firstActionDate) / (1000 * 60 * 60 * 24));
                this.historyData[index].dayDifference = dayDifference;
                this.historyData[index].differenceFromStart = dayDifferenceFromStart;
            }
            return curr;
        });
    }
    getHistoryData() {
        this.globalSlaCount = +this.dialogData.inputs.historyData.globalSla;
        this.historyData = this.dialogData.inputs.historyData?.ticketActions;
        this.prefixTicketCode = this.dialogData.inputs.prefixTicketCode;
        if (this.historyData.length > 0) {
            this.calculateDayDifferences();
        }
    }

    getCardClass(dayDifference: number): string {
        if (dayDifference >= this.globalSlaCount) {
            return 'card-red';
        }
        return dayDifference === this.globalSlaCount - 1 ? 'card-orange' : 'card-green';
    }
}
